export default "__VITE_ASSET__DhYw$038__"